import { render } from "./BadgeButton.vue?vue&type=template&id=1e851348&scoped=true"
import script from "./BadgeButton.vue?vue&type=script&lang=js"
export * from "./BadgeButton.vue?vue&type=script&lang=js"

import "./BadgeButton.vue?vue&type=style&index=0&id=1e851348&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e851348"],['__file',"src/components/button/BadgeButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e851348"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e851348', __exports__)) {
    console.log('reload')
    api.reload('1e851348', __exports__)
  }
  
  module.hot.accept("./BadgeButton.vue?vue&type=template&id=1e851348&scoped=true", () => {
    console.log('re-render')
    api.rerender('1e851348', render)
  })

}


export default __exports__